import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { Entity } from '@app/shared/models/models.interface';
import { Page } from '@app/shared/models/page.interface';
import { Observable } from 'rxjs';
import { DataTablePageState } from '../directives/datatable-pagination.directive';
import { DataTableSortState } from '../directives/datatable-sort.directive';
import { Service } from './service.interface';

@Injectable()
export class ServiceImpl<T extends Entity> implements Service<T> {
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

  getAll(endpoint: string, page: DataTablePageState, sort: DataTableSortState, filter: string): Observable<Page<T>> {
    let params = new HttpParams();
    params = params.append('filter', filter);
    params = params.append('page', page.index.toString());
    params = params.append('size', page.size.toString());
    params = params.append('sort', sort.column + ',' + sort.direction);

    return this.http.get<Page<T>>(this.appConfigService.getApi() + endpoint, {
      params
    });
  }
}
